import { c as _c } from "react/compiler-runtime";
import { ChangeRoleSubMenu } from "@components/table/members/change-role-sub-menu";
import { WorkspaceRoleMenuButton } from "@components/table/members/workspace-role-menu-button";
import { PROJECT_ROLE_XG_SEAT } from "@hooks/projects/use-project-role-xg-seat";
import { GROUP_ROLE_XG_SEAT } from "@hooks/use-group-role-xg-seat";
import { useRoleXgSeat } from "@hooks/use-role-xg-seat";
import { useChangeMemberRole } from "@hooks/use-change-member-role";
import { FaroCoreApiConst } from "@stellar/core-api-client";
/**
 * Menu button that opens a role change sub-menu with assignable roles.
 * Workspace roles are changed the same way as in the role dropdown, see WorkspaceRoleMenuButton.
 */
export function MemberRoleMenuButton(t0) {
  const $ = _c(13);
  const {
    member,
    companyId,
    subjectType,
    selectedProject,
    group,
    teamName,
    onMenuClose
  } = t0;
  if (subjectType === "workspace" || subjectType === "team") {
    const t1 = subjectType === "workspace";
    const t2 = subjectType === "team" ? teamName : undefined;
    let t3;
    if ($[0] !== companyId || $[1] !== member || $[2] !== onMenuClose || $[3] !== t1 || $[4] !== t2) {
      t3 = <WorkspaceRoleMenuButton member={member} companyId={companyId} shouldCheckXgSeat={t1} teamName={t2} onMenuClose={onMenuClose} />;
      $[0] = companyId;
      $[1] = member;
      $[2] = onMenuClose;
      $[3] = t1;
      $[4] = t2;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  if (subjectType === "project" || subjectType === "group") {
    let t1;
    if ($[6] !== companyId || $[7] !== group || $[8] !== member || $[9] !== onMenuClose || $[10] !== selectedProject || $[11] !== subjectType) {
      t1 = <ProjectOrGroupRoleMenuButton member={member} companyId={companyId} subjectType={subjectType} selectedProject={selectedProject} group={group} onMenuClose={onMenuClose} />;
      $[6] = companyId;
      $[7] = group;
      $[8] = member;
      $[9] = onMenuClose;
      $[10] = selectedProject;
      $[11] = subjectType;
      $[12] = t1;
    } else {
      t1 = $[12];
    }
    return t1;
  }
  return null;
}
/**
 * Menu button that changes the role of a member in a project or group. A role that needs a Sphere XG
 * seat asks for it first (see useRoleXgSeat), the same as in the role column, keeping the menu open
 * until the dialog for it closes.
 */
function ProjectOrGroupRoleMenuButton(t0) {
  const $ = _c(23);
  const {
    member,
    companyId,
    subjectType,
    selectedProject,
    group,
    onMenuClose
  } = t0;
  let t1;
  if ($[0] !== companyId || $[1] !== group || $[2] !== member.identity || $[3] !== member.role || $[4] !== selectedProject || $[5] !== subjectType) {
    t1 = {
      companyId,
      subjectType,
      memberIdentity: member.identity,
      currentRole: member.role,
      selectedProject,
      group,
      location: "members-role-menu-button"
    };
    $[0] = companyId;
    $[1] = group;
    $[2] = member.identity;
    $[3] = member.role;
    $[4] = selectedProject;
    $[5] = subjectType;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const {
    changeMemberRole
  } = useChangeMemberRole(t1);
  const {
    requestRoleChange,
    xgSeatDialog,
    disabledRoles: rolesAwaitingXgSeatCheck
  } = useRoleXgSeat({
    subject: subjectType === "project" ? PROJECT_ROLE_XG_SEAT : GROUP_ROLE_XG_SEAT,
    member,
    applyRoleChange: changeRole,
    onXgSeatDialogClose: onMenuClose
  });
  let t2;
  if ($[7] !== onMenuClose || $[8] !== requestRoleChange) {
    t2 = async function onRoleClicked(role) {
      if (!(await requestRoleChange(role))) {
        onMenuClose();
      }
    };
    $[7] = onMenuClose;
    $[8] = requestRoleChange;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const onRoleClicked = t2;
  async function changeRole(role_0) {
    try {
      await changeMemberRole(role_0);
    } catch {}
  }
  const t3 = subjectType === "project" ? FaroCoreApiConst.allProjectRoles : FaroCoreApiConst.allGroupRoles;
  let t4;
  if ($[10] !== rolesAwaitingXgSeatCheck || $[11] !== subjectType) {
    t4 = subjectType === "project" ? ["RESOURCE_OWNER", ...rolesAwaitingXgSeatCheck] : rolesAwaitingXgSeatCheck;
    $[10] = rolesAwaitingXgSeatCheck;
    $[11] = subjectType;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== onRoleClicked) {
    t5 = role_1 => void onRoleClicked(role_1);
    $[13] = onRoleClicked;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== member.role || $[16] !== t3 || $[17] !== t4 || $[18] !== t5) {
    t6 = <ChangeRoleSubMenu roles={t3} disabledRoles={t4} selectedRole={member.role} onRoleClick={t5} />;
    $[15] = member.role;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t6 || $[21] !== xgSeatDialog) {
    t7 = <>{t6}{xgSeatDialog}</>;
    $[20] = t6;
    $[21] = xgSeatDialog;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
}